import type { useI18n } from '~/i18n/index.tsx';

/** An audit entry's action in words, or the code itself for one that has no name yet. */
export function auditActionLabel(action: string, t: ReturnType<typeof useI18n>['t']): string {
  const key = `audit.${action}` as Parameters<typeof t>[0];
  const label = t(key);

  return label === key ? action : label;
}
